import { isWorkHomeEvidenceMode } from '@/components/layout/Navigation/hooks/isWorkHomeEvidenceMode';
import { useOpenEvidenceHome } from '@/components/layout/Navigation/hooks/useOpenEvidenceHome';
import { trackNavV3ButtonClicked } from '@/components/layout/Navigation/nav-v3/nav-v3-analytics';
import { navV3Messages } from '@/components/layout/Navigation/nav-v3/nav-v3.messages';
import { NavItem } from '@/components/layout/Navigation/sidebar/nav-item';
import { currentWorkHomeViewAtom, currentWorkModeAtom } from '@heidi/agents/data';
import { useAtomValue } from 'jotai';
import { Microscope } from 'lucide-react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../../mobile/use-mobile-panel';

export const EvidenceHomeNavItem = () => {
  const intl = useIntl();
  const openEvidenceHome = useOpenEvidenceHome();
  const { dismissMobileSidebar } = useMobilePanel();
  const currentWorkHomeView = useAtomValue(currentWorkHomeViewAtom);
  const currentWorkMode = useAtomValue(currentWorkModeAtom);

  const onClick = useCallback(() => {
    trackNavV3ButtonClicked({ label: 'nav_v3_evidence' });
    openEvidenceHome();
    dismissMobileSidebar();
  }, [dismissMobileSidebar, openEvidenceHome]);

  return (
    <NavItem
      label={intl.formatMessage(navV3Messages.evidence)}
      icon={<Microscope />}
      onClick={onClick}
      isActive={isWorkHomeEvidenceMode(currentWorkHomeView, currentWorkMode)}
      testId="sidebar-link-evidence"
    />
  );
};
